var $903f483b4d2e61cf$exports = {};
$903f483b4d2e61cf$exports = {
    "info": `Informacije`,
    "negative": `Gre\u{161}ka`,
    "positive": `Uspe\u{161}no`
};


export {$903f483b4d2e61cf$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
